<div class="mfa-management-container">
  <div class="management-card">
    <div class="card-header">
      <h2>多因素認證管理</h2>
      <p>管理您的多因素認證設定</p>
    </div>

    <div class="card-body">
      <!-- MFA Status -->
      <div class="status-section">
        <h3>目前狀態</h3>
        <div class="status-info">
          <div class="status-item">
            <span class="label">MFA 狀態：</span>
            <span class="status" [class.enabled]="mfaStatus.isEnabled" [class.disabled]="!mfaStatus.isEnabled">
              {{ mfaStatus.isEnabled ? '已啟用' : '未啟用' }}
            </span>
          </div>
          <div class="status-item" *ngIf="mfaStatus.isEnabled">
            <span class="label">備用碼：</span>
            <span class="status" [class.available]="mfaStatus.hasBackupCodes" [class.unavailable]="!mfaStatus.hasBackupCodes">
              {{ mfaStatus.hasBackupCodes ? '可用' : '不可用' }}
            </span>
          </div>
          <div class="status-item" *ngIf="mfaStatus.setupDate">
            <span class="label">設定日期：</span>
            <span class="date">{{ mfaStatus.setupDate | date:'yyyy/MM/dd HH:mm' }}</span>
          </div>
        </div>
      </div>

      <!-- Actions Section -->
      <div class="actions-section">
        <h3>可用操作</h3>
        
        <!-- Enable MFA -->
        <div class="action-card" *ngIf="!mfaStatus.isEnabled">
          <div class="action-info">
            <i class="fas fa-shield-alt"></i>
            <div class="action-text">
              <h4>啟用多因素認證</h4>
              <p>設定多因素認證以提升您的帳戶安全性</p>
            </div>
          </div>
          <button class="btn btn-primary" (click)="navigateToSetup()">
            <i class="fas fa-plus"></i>
            啟用 MFA
          </button>
        </div>

        <!-- Regenerate Backup Codes -->
        <div class="action-card" *ngIf="mfaStatus.isEnabled">
          <div class="action-info">
            <i class="fas fa-key"></i>
            <div class="action-text">
              <h4>重新生成備用碼</h4>
              <p>產生新的備用碼，舊的備用碼將會失效</p>
            </div>
          </div>
          <button class="btn btn-warning" (click)="showRegenerateDialog()">
            <i class="fas fa-refresh"></i>
            重新生成
          </button>
        </div>

        <!-- Disable MFA -->
        <div class="action-card danger" *ngIf="mfaStatus.isEnabled">
          <div class="action-info">
            <i class="fas fa-ban"></i>
            <div class="action-text">
              <h4>停用多因素認證</h4>
              <p>停用 MFA 會降低您的帳戶安全性</p>
            </div>
          </div>
          <button class="btn btn-danger" (click)="showDisableDialog()">
            <i class="fas fa-times"></i>
            停用 MFA
          </button>
        </div>
      </div>

      <!-- Back Button -->
      <div class="navigation-section">
        <button class="btn btn-secondary" (click)="goBack()">
          <i class="fas fa-arrow-left"></i>
          返回主頁
        </button>
      </div>
    </div>
  </div>

  <!-- Disable MFA Dialog -->
  <div class="modal" *ngIf="showDisableConfirmation">
    <div class="modal-content">
      <div class="modal-header">
        <h3>停用多因素認證</h3>
        <button class="close-btn" (click)="hideDisableDialog()">×</button>
      </div>
      
      <div class="modal-body">
        <div class="warning-message">
          <i class="fas fa-exclamation-triangle"></i>
          <span>停用 MFA 將會降低您的帳戶安全性。請確認您要繼續。</span>
        </div>

        <div *ngIf="errors.disable" class="error-message">
          <i class="fas fa-exclamation-circle"></i>
          <span>{{ errors.disable }}</span>
        </div>

        <form [formGroup]="disableForm" (ngSubmit)="onDisableMfa()">
          <div class="form-group">
            <label for="disableVerificationCode">驗證碼</label>
            <input type="text" 
                   id="disableVerificationCode"
                   class="form-control"
                   formControlName="verificationCode"
                   placeholder="請輸入 6 位數驗證碼"
                   maxlength="6"
                   autocomplete="off">
            
            <div *ngIf="disableForm.get('verificationCode')?.invalid && disableForm.get('verificationCode')?.touched" 
                 class="error-text">
              請輸入有效的 6 位數驗證碼
            </div>
          </div>

          <div class="form-group">
            <label for="disablePassword">密碼</label>
            <input type="password" 
                   id="disablePassword"
                   class="form-control"
                   formControlName="password"
                   placeholder="請輸入您的登入密碼"
                   autocomplete="current-password">
            
            <div *ngIf="disableForm.get('password')?.invalid && disableForm.get('password')?.touched" 
                 class="error-text">
              請輸入密碼
            </div>
          </div>

          <div class="button-group">
            <button type="submit" 
                    class="btn btn-danger"
                    [disabled]="disableForm.invalid || loading.disable">
              <span *ngIf="loading.disable" class="spinner"></span>
              <i *ngIf="!loading.disable" class="fas fa-ban"></i>
              {{ loading.disable ? '處理中...' : '確認停用' }}
            </button>
            
            <button type="button" 
                    class="btn btn-secondary"
                    (click)="hideDisableDialog()"
                    [disabled]="loading.disable">
              取消
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Regenerate Backup Codes Dialog -->
  <div class="modal" *ngIf="showRegenerateConfirmation">
    <div class="modal-content">
      <div class="modal-header">
        <h3>重新生成備用碼</h3>
        <button class="close-btn" (click)="hideRegenerateDialog()">×</button>
      </div>
      
      <div class="modal-body">
        <div class="warning-message">
          <i class="fas fa-exclamation-triangle"></i>
          <span>重新生成備用碼將會使現有的備用碼失效。</span>
        </div>

        <div *ngIf="errors.regenerate" class="error-message">
          <i class="fas fa-exclamation-circle"></i>
          <span>{{ errors.regenerate }}</span>
        </div>

        <form [formGroup]="regenerateForm" (ngSubmit)="onRegenerateBackupCodes()">
          <div class="form-group">
            <label for="regenerateVerificationCode">驗證碼</label>
            <input type="text" 
                   id="regenerateVerificationCode"
                   class="form-control"
                   formControlName="verificationCode"
                   placeholder="請輸入 6 位數驗證碼"
                   maxlength="6"
                   autocomplete="off">
            
            <div *ngIf="regenerateForm.get('verificationCode')?.invalid && regenerateForm.get('verificationCode')?.touched" 
                 class="error-text">
              請輸入有效的 6 位數驗證碼
            </div>
          </div>

          <div class="button-group">
            <button type="submit" 
                    class="btn btn-warning"
                    [disabled]="regenerateForm.invalid || loading.regenerate">
              <span *ngIf="loading.regenerate" class="spinner"></span>
              <i *ngIf="!loading.regenerate" class="fas fa-refresh"></i>
              {{ loading.regenerate ? '處理中...' : '確認重新生成' }}
            </button>
            
            <button type="button" 
                    class="btn btn-secondary"
                    (click)="hideRegenerateDialog()"
                    [disabled]="loading.regenerate">
              取消
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- New Backup Codes Display -->
  <div class="modal" *ngIf="showBackupCodes">
    <div class="modal-content large">
      <div class="modal-header">
        <h3>新的備用碼</h3>
        <button class="close-btn" (click)="hideBackupCodes()">×</button>
      </div>
      
      <div class="modal-body">
        <div class="success-message">
          <i class="fas fa-check-circle"></i>
          <span>備用碼已成功重新生成！</span>
        </div>

        <div class="backup-codes-section">
          <h4>請妥善保存以下新的備用碼</h4>
          <p>每個備用碼只能使用一次，當您無法存取驗證器應用程式時可以使用。</p>
          
          <div class="backup-codes">
            <div *ngFor="let code of newBackupCodes" class="backup-code">
              {{ code }}
            </div>
          </div>
          
          <div class="backup-codes-warning">
            <i class="fas fa-exclamation-triangle"></i>
            <span>請將這些備用碼儲存在安全的地方。舊的備用碼已經失效。</span>
          </div>
        </div>

        <div class="button-group">
          <button class="btn btn-primary" (click)="hideBackupCodes()">
            <i class="fas fa-check"></i>
            我已保存備用碼
          </button>
        </div>
      </div>
    </div>
  </div>
</div>